// src/components/website/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <h3>🛡️ CivicSetu</h3>
          <p>
            India's emergency QR code platform. Helping families, schools
            and institutions stay safe with instant emergency contact access.
          </p>
          <div style={{ marginTop: 16, fontSize: 13 }}>
            📧 info@civicsetu.in
          </div>
        </div>

        <div className="footer-col">
          <h4>Product</h4>
          <ul>
            <li><Link to="/#how-it-works">How It Works</Link></li>
            <li><Link to="/#features">Features</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/bulk/login">Bulk Orders</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><a href="https://civicsetu.in/terms" target="_blank" rel="noreferrer">Terms of Service</a></li>
            <li><a href="https://civicsetu.in/privacy" target="_blank" rel="noreferrer">Privacy Policy</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Download</h4>
          <ul>
            <li>
              <a
                href="https://play.google.com/store/apps/details?id=com.civicsetu.app"
                target="_blank"
                rel="noreferrer"
              >
                📱 Android App
              </a>
            </li>
            <li><a href="/admin">Admin Panel</a></li>
          </ul>
          <div style={{ marginTop: 16, fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>
            Made with ❤️ in India
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© 2026 CivicSetu. All rights reserved.</span>
        <span>🇮🇳 Proudly Indian</span>
      </div>
    </footer>
  );
}
